import React, { useState } from "react";
import { Modal } from "antd";
import ImumProductTag from "./ImumProductTag";
import ButtonSecondary from "../common/ButtonSecondary";
import { useDispatch } from "react-redux";
import useFetch from "../../hooks/useFetch";
import ImumProductTagAction from "./ImumProductTagAction";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { imumProductTagAction } from "../../redux/Actions/imum_product_tags_action";

const initial_values = {
  id: null,
  values: {},
};
const ImumProductTagManagerPreview = ({ showModal, setShowModal, context }) => {
  const [globalTag, setGlobalTag] = React.useState(false);
  const tagsUrl =
    context === "retail"
      ? `/api/v1/retail_product_tags`
      : `/api/v1/${window.identifier}/imum_product_tags`;
  const { value: imum_product_tags = [], setValue } = useFetch(tagsUrl);
  const dispatch = useDispatch();
  const [action, setAction] = useState(initial_values);
  // fetch all
  const func_logic = {
    update: {
      first: "Delete tag",
      firstFunc: () => {
        setAction(initial_values);
        setValue((prev) => {
          let dta = [...prev];
          const item_id = dta.find((d) => d.id == action.id).id;
          if (typeof item_id == "string") {
            dta = dta.filter((d) => d.id !== action.id);
          } else {
            dta = dta.map((d) =>
              d.id == action.id ? { ...d, _destroy: 1, updated_at: null } : d
            );
          }

          return dta;
        });
      },
      second: "Save tag information",
      secondFunc: () => {
        if (action.values.title == "") return;

        setValue((prev) => {
          let dta = [...prev];
          dta = dta.map((d) =>
            d.id == action.id ? { ...d, ...action.values, updated_at: null } : d
          );
          return dta;
        });
        setAction(initial_values);
      },
    },
    create: {
      first: "Discard new tag",
      firstFunc: () => {
        setAction(initial_values);
      },
      second: "Save new tag",
      secondFunc: () => {
        if (action.values.title == "") return;
        // console.log('set new tag')
        setValue((prev) => [
          ...prev,
          {
            id: "Cu" + Math.floor(Math.random() * 100),
            color: action.values.color,
            title: action.values.title,
            valid_from: action.values.valid_from ? action.values.valid_from.toISOString() : null,
            valid_to: action.values.valid_to ? action.values.valid_to.toISOString() : null,
            expiration_action: action.values.expiration_action || "keep_rules",
            sort: prev.length + 1,
            updated_at: null,
          },
        ]);
        setAction(initial_values);
      },
    },
    none: {
      first: "Add new special tag",
      firstFunc: () => {
        setAction({
          id: 0,
          values: {
            color: "",
            title: "",
            expiration_action: "keep_rules",
          },
        });
      },
      second: "Save and close",
      secondFunc: async () => {
        const { success } = await dispatch(
          imumProductTagAction(imum_product_tags, globalTag, context)
        );
        if (success) setShowModal(false);
        console.log("Save everything!!!: ".data);
      },
    },
  };

  const type =
    typeof action?.id == "number" && action?.id == 0
      ? "create"
      : typeof action?.id == "number" && action?.id > 0
        ? "update"
        : "none";

  // Draggable actions
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };
  function onDragEnd(result) {
    // return console.log({ result });
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    const draggable_arr = reorder(
      imum_product_tags,
      result.source.index,
      result.destination.index
    );
    const updated_array = draggable_arr.map((e, idx) => ({
      ...e,
      sort: idx + 1,
      updated_at: null,
    }));
    console.log({ updated_array });
    setValue(updated_array);
  }
  return (
    <Modal
      style={{
        width: 320,
      }}
      title={"Manage tags"}
      visible={showModal}
      onCancel={() => setShowModal(false)}
      cancelText="Close"
      okButtonProps={{ style: { display: "none" } }}
      footer={[
        <>
          {!!type && (
            <>
              <ButtonSecondary
                outline={true}
                onClick={() => {
                  func_logic[type].firstFunc();
                }}
              >
                {func_logic[type].first}
              </ButtonSecondary>
              <div className="my-1"></div>
              <ButtonSecondary
                onClick={() => {
                  console.log("Save!");
                  func_logic[type].secondFunc();
                }}
              >
                {func_logic[type].second}
              </ButtonSecondary>
            </>
          )}
        </>,
      ]}
    >
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div
              className="d-flex flex-column"
              ref={provided.innerRef}
              {...provided.droppableProps}
            >
              {imum_product_tags.map((d, idx) =>
                d._destroy ? null : (
                  <Draggable key={d.id} draggableId={`${d.id}-id`} index={idx}>
                    {(provided, snapshot) => (
                      <div
                        key={d.id}
                        ref={provided.innerRef}
                        style={provided.draggableProps.style}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <ImumProductTag
                          {...d}
                          action={action}
                          setAction={setAction}
                          onEdit={(val) => setAction(val)}
                          globalTag={globalTag}
                          setGlobalTag={setGlobalTag}
                          context={context}
                        />
                      </div>
                    )}
                  </Draggable>
                )
              )}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      {action?.id == 0 && (
        <ImumProductTagAction
          action={action.values}
          setAction={setAction}
          globalTag={globalTag}
          setGlobalTag={setGlobalTag}
          context={context}
        />
      )}
    </Modal>
  );
};

export default ImumProductTagManagerPreview;
